import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ApplicationHostTypeService, HistoryService, RomeUiLoaderModule, UserSessionService } from 'rome-library';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UiLoaderConfig } from './core/constants/ui-loader-config';
import { CoreModule } from './core/core.module';
import { AuthorizationInterceptor } from './core/interceptors/authorization-interceptor';
import { NotificationsInterceptor } from './core/interceptors/notifications-interceptor';
import { ConfigurationService } from './core/services/configuration.service';
import { ErrorLoggerService } from './core/services/error-logger.service';
import { ExternalUserSessionService } from './core/services/external-user-session.service';
import { GlobalErrorHandlerService } from './core/services/global-error-handler.service';
import { States } from './shared/constants/states';
import { BoiGoogleTagManagerModule } from './tag-manager/boi-google-tag-manager.module';

export function initApplicationConfiguration(
  config: ConfigurationService,
  applicationHostTypeService: ApplicationHostTypeService,
  httpClient: HttpClient,
  userSessionService: UserSessionService,
  historyService: HistoryService
): () => Promise<boolean> {
  applicationHostTypeService.updateCode();
  applicationHostTypeService.updateFavicon();

  httpClient.get('/ExternalConfiguration/GetInterfaceTypeId').subscribe((interfaceType: number) => {
    applicationHostTypeService.setInterfaceType(interfaceType);
  });

  historyService.initialize([States.SessionClosed, States.Logout]);

  return async () =>
    config.loadDefaultApplicationConfiguration().then((loaded) => {
      userSessionService.initialize();

      return loaded;
    });
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BoiGoogleTagManagerModule,
    RomeUiLoaderModule.forRoot(UiLoaderConfig)
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initApplicationConfiguration,
      deps: [ConfigurationService, ApplicationHostTypeService, HttpClient, UserSessionService, HistoryService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationsInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    },
    {
      provide: UserSessionService,
      useClass: ExternalUserSessionService
    },
    ErrorLoggerService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
